export const formatImportesDatosEconomicos = (importesModel) => {
  const attributes = { title: importesModel.operation };
  const relationships = {};
  if (importesModel.importe || importesModel.importe === 0) {
    attributes.importe_inversion = importesModel.importe;
  }
  if (importesModel.tin || importesModel.tin === 0) {
    attributes.tipo_interes = importesModel.tin;
  }
  if (importesModel.tae || importesModel.tae === 0) {
    attributes.tae = importesModel.tae;
  }
  if (importesModel.responsabilidad || importesModel.responsabilidad === 0) {
    attributes.responsabilidad_hipotecaria = importesModel.responsabilidad;
  }
  if (importesModel.plazo) {
    attributes.plazo_prestamo = importesModel.plazo;
  }
  if (importesModel.cuotas) {
    attributes.operacion_por_cuotas = importesModel.cuotas;
  }
  if (importesModel.renovable) {
    attributes.renovable = importesModel.renovable;
  }
  if (importesModel.interesRenovacion || importesModel.interesRenovacion === 0) {
    attributes.interes_renovacion = importesModel.interesRenovacion;
  }
  if (importesModel.tinReal) {
    attributes.tipo_interes_real = importesModel.tinReal;
  }
  if (importesModel.otros || importesModel.otros === 0) {
    attributes.otros = importesModel.otros;
  }
  if (importesModel.letra) {
    attributes.letra = importesModel.letra === 'Si';
  }
  if (importesModel.tca) {
    attributes.tipo_comision_apertura = importesModel.tca;
  }
  if (importesModel.cargasAnteriores || importesModel.cargasAnteriores === 0) {
    attributes.cargas_anteriores_cancelar = importesModel.cargasAnteriores;
  }

  const id = importesModel.id && importesModel.id !== 'dummy' ? importesModel.id : undefined;
  return {
    data: {
      type: 'node--volume',
      id,
      attributes,
      relationships,
    },
  };
};

export const formatGastosDatosEconomicos = (gastosModel) => {
  const attributes = { title: gastosModel.operation };
  const relationships = {};
  if (gastosModel.notario || importesModel.notario === 0) {
    attributes.notario = gastosModel.notario;
  }
  if (gastosModel.registro || importesModel.registro === 0) {
    attributes.registro = gastosModel.registro;
  }
  if (gastosModel.gestoria || importesModel.gestoria === 0) {
    attributes.gestoria = gastosModel.gestoria;
  }
  if (gastosModel.seguro || importesModel.seguro === 0) {
    attributes.seguro = gastosModel.seguro;
  }
  if (gastosModel.timbres || importesModel.timbres === 0) {
    attributes.timbres = gastosModel.timbres;
  }
  if (gastosModel.hacienda || importesModel.hacienda === 0) {
    attributes.hacienda = gastosModel.hacienda;
  }
  if (gastosModel.varios || importesModel.varios === 0) {
    attributes.varios = gastosModel.varios;
  }
  if (gastosModel.tipoHacienda) {
    attributes.tipo_hacienda = gastosModel.tipoHacienda;
  }
  // if (gastosModel.tipoHacienda) {
  //   relationships.comunidad = {
  //     data: { type: 'taxonomy_term--comunidades', id: gastosModel.tipoHacienda },
  //   };
  // }
  if (gastosModel.operacion) {
    relationships.operacion = {
      data: [{ type: 'node--operation', id: gastosModel.operacion }],
    };
  }
  const id = gastosModel.id && gastosModel.id !== 'dummy' ? gastosModel.id : undefined;
  return {
    data: {
      type: 'node--expenses',
      id,
      attributes,
      relationships,
    },
  };
};


export const formatInstanciaLetra = (model) => {
  const request = {
    id: model.id && model.id !== 'dummy' && model.id !== '' ? model.id : undefined,
    type: 'node--instancia_letra',
  };
  const attributes = {};
  const relationships = {};
  if ('title' in model) {
    attributes.title = model.title;
  } else {
    attributes.title = `Instancia Letra - ${Date.now()}`;
  }
  if ('valor' in model) {
    attributes.valor = model.valor;
  }
  if ('valorCesion' in model) {
    attributes.valor_en_cesion = model.valorCesion;
  }
  if (model.tipoLetra && model.tipoLetra !== '' && model.tipoLetra !== 'dummy') {
    relationships.tipo_letra = {
      data: {
        id: model.tipoLetra,
        type: 'taxonomy_term--letra',
      },
    };
  }
  return {
    data: Object.assign({}, request, { attributes, relationships }),
  };
};

export const processImportesDatosEconomicos = (importes) => {
  const importesModel = {};
  importesModel.id = importes.id;
  importesModel.type = importes.type;
  const { attributes, relationships } = importes;
  importesModel.title = attributes.title;
  if (attributes.importe_inversion) {
    importesModel.importe = attributes.importe_inversion;
  }
  if (attributes.tipo_interes) {
    importesModel.tin = attributes.tipo_interes;
  }
  if (attributes.tae) {
    importesModel.tae = attributes.tae;
  }
  if (attributes.responsabilidad_hipotecaria) {
    importesModel.responsabilidad = attributes.responsabilidad_hipotecaria;
  }
  if (attributes.plazo_prestamo) {
    importesModel.plazo = attributes.plazo_prestamo;
  }
  if (attributes.operacion_por_cuotas) {
    importesModel.cuotas = attributes.operacion_por_cuotas;
  }
  if (attributes.renovable) {
    importesModel.renovable = attributes.renovable;
  }
  if (attributes.interes_renovacion) {
    importesModel.interesRenovacion = attributes.interes_renovacion;
  }
  if (attributes.tipo_interes_real) {
    importesModel.tinReal = attributes.tipo_interes_real;
  }
  if (attributes.otros) {
    importesModel.otros = attributes.otros;
  }
  if (attributes.letra) {
    importesModel.letra = attributes.letra === true ? 'Si' : 'No';
  }
  if (attributes.tipo_comision_apertura) {
    importesModel.tca = attributes.tipo_comision_apertura;
  }
  if (attributes.cargas_anteriores_cancelar) {
    importesModel.cargasAnteriores = attributes.cargas_anteriores_cancelar;
  }

  if (relationships.id_operacion) {
    if (relationships.id_operacion.data && relationships.id_operacion.data.length > 0) {
      importesModel.operation = relationships.id_operacion.data[0].id;
    }
  }
  return importesModel;
};

export const processGastosDatosEconomicos = (gastos) => {
  const gastosModel = {};
  gastosModel.id = gastos.id;
  gastosModel.type = gastos.type;
  const { attributes, relationships } = gastos;
  gastosModel.title = attributes.title;
  if (attributes.notario) {
    gastosModel.notario = attributes.notario;
  }
  if (attributes.registro) {
    gastosModel.registro = attributes.registro;
  }
  if (attributes.gestoria) {
    gastosModel.gestoria = attributes.gestoria;
  }
  if (attributes.timbres) {
    gastosModel.timbres = attributes.timbres;
  }
  if (attributes.seguro) {
    gastosModel.seguro = attributes.seguro;
  }
  if (attributes.hacienda) {
    gastosModel.hacienda = attributes.hacienda;
  }
  if (attributes.varios) {
    gastosModel.varios = attributes.varios;
  }
  if (attributes.tipo_hacienda) {
    gastosModel.tipoHacienda = attributes.tipo_hacienda;
  }
  if (relationships.operacion) {
    if (relationships.operacion.data) {
      gastosModel.operacion = relationships.operacion.data.id;
    }
  }
  // if (relationships.comunidad) {
  //   if (relationships.comunidad.data) {
  //     gastosModel.tipoHacienda = relationships.comunidad.data.id;
  //   }
  // }
  return gastosModel;
};

export const processInstanciaLetra = (letra) => {
  const model = {
    id: letra.id,
    type: letra.type,
  };
  const { attributes, relationships } = letra;
  if ('title' in attributes) {
    model.title = attributes.title;
  }
  if ('valor' in attributes) {
    model.valor = attributes.valor;
  }
  if ('valor_en_cesion' in attributes) {
    model.valorCesion = attributes.valor_en_cesion;
  }
  if ('tipo_letra' in relationships && relationships.tipo_letra.data && relationships.tipo_letra.data.id) {
    model.tipoLetra = relationships.tipo_letra.data.id;
  }
  return model;
};

export const processInstanciaLetraResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(letra => processInstanciaLetra(letra));
  }
  return processInstanciaLetra(res.data.data);
};




// WEBPACK FOOTER //
// ./src/features/tab-datos-economicos/utils.js